export const space = {
	xxl: {
		desktop: 96,
		tablet: 80,
		mobile: 64,
	},
	xl: {
		desktop: 80,
		tablet: 64,
		mobile: 40,
	},
	l: {
		desktop: 64,
		tablet: 40,
		mobile: 32,
	},
	m: {
		desktop: 40,
		tablet: 32,
		mobile: 24,
	},
	s: {
		desktop: 24,
		tablet: 24,
		mobile: 16,
	},
	xs: {
		desktop: 16,
		tablet: 16,
		mobile: 12,
	},
	xxs: {
		desktop: 8,
		tablet: 8,
		mobile: 4,
	},
};

const displayLeading = {
	xxl: {
		desktop: 105,
		tablet: 94,
		mobile: 80,
	},
	xl: {
		desktop: 70,
		tablet: 66,
		mobile: 80,
	},
	l: {
		desktop: 58,
		tablet: 51,
		mobile: 44,
	},
	m: {
		desktop: 50,
		tablet: 45,
		mobile: 40,
	},
	s: {
		desktop: 40,
		tablet: 35,
		mobile: 30,
	},
	xs: {
		desktop: 30,
		tablet: 25,
		mobile: 25,
	},
};
const titleLeading = {
	l: {
		desktop: 35,
		tablet: 35,
		mobile: 30,
	},
	m: {
		desktop: 30,
		tablet: 27,
		mobile: 25,
	},
	s: {
		desktop: 25,
		tablet: 25,
		mobile: 22.5,
	},
	xs: {
		desktop: 22.5,
		tablet: 22,
		mobile: 20,
	},
};
const bodyLeading = {
	l: {
		desktop: 30,
		tablet: 25,
		mobile: 22.5,
	},
	m: {
		desktop: 24,
		tablet: 21,
		mobile: 21,
	},
	s: {
		desktop: 24,
		tablet: 21,
		mobile: 21,
	},
	xs: {
		desktop: 21,
		tablet: 18,
		mobile: 18,
	},
};
const labelLeading = {
	l: {
		desktop: 19,
		tablet: 18,
		mobile: 16,
	},
	m: {
		desktop: 16,
		tablet: 15,
		mobile: 14,
	},
	s: {
		desktop: 14,
		tablet: 13,
		mobile: 12,
	},
	xs: {
		desktop: 12,
		tablet: 12,
		mobile: 11,
	},
};
const ctaLeading = {
	m: {
		desktop: 19,
		tablet: 18,
		mobile: 16,
	},
	s: {
		desktop: 16,
		tablet: 15,
		mobile: 14,
	},
};

export const leading = {
	extended: {
		desktop: "150%",
		tablet: "150%",
		mobile: "150%",
	},
	spacious: {
		desktop: "134%",
		tablet: "134%",
		mobile: "134%",
	},
	comfy: {
		desktop: "125%",
		tablet: "125%",
		mobile: "125%",
	},
	compact: {
		desktop: "117%",
		tablet: "117%",
		mobile: "117%",
	},
	display: displayLeading,
	title: titleLeading,
	body: bodyLeading,
	label: labelLeading,
	cta: ctaLeading,
};

export const radii = {
	full: {
		desktop: 120,
		tablet: 120,
		mobile: 120,
	},
	l: {
		desktop: 16,
		tablet: 12,
		mobile: 12,
	},
	m: {
		desktop: 12,
		tablet: 8,
		mobile: 8,
	},
	s: {
		desktop: 8,
		tablet: 4,
		mobile: 4,
	},
};

export const border = {
	l: {
		desktop: 4,
		tablet: 4,
		mobile: 4,
	},
	m: {
		desktop: 2,
		tablet: 2,
		mobile: 2,
	},
	s: {
		desktop: 1,
		tablet: 1,
		mobile: 1,
	},
};

const displayFontSize = {
	xxl: {
		desktop: 90,
		tablet: 80,
		mobile: 68,
	},
	xl: {
		desktop: 60,
		tablet: 56,
		mobile: 50,
	},
	l: {
		desktop: 50,
		tablet: 44,
		mobile: 38,
	},
	m: {
		desktop: 40,
		tablet: 36,
		mobile: 30,
	},
	s: {
		desktop: 32,
		tablet: 28,
		mobile: 24,
	},
	xs: {
		desktop: 20,
		tablet: 20,
		mobile: 16,
	},
};
const titleFontSize = {
	l: {
		desktop: 28,
		tablet: 28,
		mobile: 24,
	},
	m: {
		desktop: 24,
		tablet: 22,
		mobile: 20,
	},
	s: {
		desktop: 20,
		tablet: 20,
		mobile: 18,
	},
	xs: {
		desktop: 18,
		tablet: 18,
		mobile: 14,
	},
};
const bodyFontSize = {
	l: {
		desktop: 24,
		tablet: 24,
		mobile: 20,
	},
	m: {
		desktop: 18,
		tablet: 18,
		mobile: 16,
	},
	s: {
		desktop: 16,
		tablet: 16,
		mobile: 14,
	},
	xs: {
		desktop: 14,
		tablet: 14,
		mobile: 12,
	},
};
const labelFontSize = {
	l: bodyFontSize.s,
	m: bodyFontSize.xs,
	s: {
		desktop: 12,
		tablet: 12,
		mobile: 10,
	},
	xs: {
		desktop: 10,
		tablet: 10,
		mobile: 9,
	},
};
const ctaFontSize = {
	m: {
		desktop: 16,
		tablet: 16,
		mobile: 14,
	},
	s: {
		desktop: 14,
		tablet: 14,
		mobile: 12,
	},
};

export const fontSize = {
	display: displayFontSize,
	title: titleFontSize,
	body: bodyFontSize,
	label: labelFontSize,
	cta: ctaFontSize,
};

export const fontFamily = {
	sans: "Arial, sans-serif",
	serif: "Georgia, serif",
};

export const color = {
	purple: "#470054",
	violet: "#804093",
	lightViolet: "#BFA3DC",
	darkTeal: "#00676E",
	midTeal: "#00818A",
	lightTeal: "#66B3B9",
	white: "#FFFFFF",
	chalk: "#F2F2F2",
	sand: "#F2EDEC",
	grey: "#E6E2E8",
	charcoal: "#333333",
	watermelon: "#E51A4D",
	leaf: "#008234",
	midnight: "#222222",
	fog: "#5E6675",
	mist: "#908B9C",
	cloud: "#D1D8DC",
	ice: "#F2F3F4",
	sun: "#EB7306",
	wine: "#AD4F7E",
	rose: "#C377AE",
	lavender: "#888FCD",
	azure: "#2AA0CB",
	purple60: "#916698",
	teal60: "#66B3B9",
	sun60: "#F3AB6A",
	fog60: "#9EA3AC",
	wine60: "#CE95B2",
	silver: "#8D8D8C",
	mist60: "#BCB9C4",
	lavender60: "#B8BCE1",
};

export const breakpoints = {
	s: 375,
	gtXS: 576,
	m: 768,
	l: 992,
	xl: 1340,
};

export const PieColors = [
	color.purple,
	color.purple60,
	color.darkTeal,
	color.teal60,
	color.wine,
	color.wine60,
];

export const BarColors = [color.purple, color.darkTeal];
